import { create } from 'zustand';
import { TPartnerStore } from './domain';
import { DEFAULT_PARTNER_STATE } from './state';
import { getPartnerBySlug } from '@/service/api/Partner/getPartnerBySlug';
import { getTexts } from '@/service/api/Texts/getTexts';

export const usePartnerStore = create<TPartnerStore>((set) => ({
    ...DEFAULT_PARTNER_STATE,
    initPartnerData: async (slug) => {
        const [partner, texts] = await Promise.all([getPartnerBySlug(slug), getTexts(slug)]);

        if (partner && partner.id) {
            if (texts && Object.values(texts).some((value) => value !== '')) {
                set({
                    ...partner,
                    ...(!!texts && { texts }),
                });
            } else {
                set(partner);
            }
        }
    },
    setupPartner: async (partner) => {
        if (partner && partner.id) {
            set(partner);

            const texts = await getTexts(partner.id);

            if (texts && Object.values(texts).some((value) => value !== '')) {
                set((state) => ({ ...state, texts }));
            }
        }
    },
    setIsLightframePage: (isLightframePage) => set({ isLightframePage }),
}));
